import { jsxs as x, jsx as e } from "@emotion/react/jsx-runtime";
import { RightComponentContainer as m, PasswordToggle as h } from "./RightComponent.styled.js";
import { Snippet as g } from "../../../Snippet/index.js";
import { UnitLabel as y } from "../UnitLabel/UnitLabel.js";
const j = ({
  type: i,
  value: t,
  isPasswordVisible: o = !1,
  togglePassword: l,
  unit: r,
  isDropdown: s,
  readOnly: n,
  copy: a,
  copyText: d,
  copiedText: p,
  disabled: c,
  className: f
}) => /* @__PURE__ */ x(m, { isDropdown: s, disabled: c, className: f, readOnly: n, copy: a, children: [
  i === "password" && /* @__PURE__ */ e(h, { "aria-label": o ? "hide password" : "show password", dataTrackId: "textfield-pass-toggleable", onClick: l, icon: [o ? "fa-eye" : "fa-eye-slash"], color: "secondary", style: {
    cursor: "pointer"
  } }, "textfield-pass-toggleable"),
  a && t && /* @__PURE__ */ e("div", { style: {
    display: "flex",
    justifyContent: "center",
    width: "24px"
  }, children: /* @__PURE__ */ e(g, { dataTrackId: "copy__textfield", copiedText: p ?? "", copyText: d ?? "", value: t, variant: "text" }) }),
  r && /* @__PURE__ */ e(y, { children: r }, "unit-label")
] });
export {
  j as RightComponent
};
